import { Component, Input } from '@angular/core';

/**
 * Avatar con iniziali (restyling 2026, pag. 22-23 scheda design).
 * Max 2 lettere anche con doppi nomi/cognomi; ignora i titoli (Dr., Dr.ssa, Prof., ...).
 * Uso: <app-avatar-iniziali [nome]="consulto.medico_cognomenome"></app-avatar-iniziali>
 */
@Component({
    selector: 'app-avatar-iniziali',
    standalone: true,
    template: `<span class="dt-avatar"
        [class.dt-avatar-sm]="size === 'sm'"
        aria-hidden="true">{{ iniziali }}</span>`,
})
export class AvatarInizialiComponent {
    @Input() size: 'md' | 'sm' = 'md';

    iniziali = '';

    private static readonly TITOLI = /^(dr|dr\.ssa|dott|dott\.ssa|prof|prof\.ssa|sig|sig\.ra)\.?$/i;

    /** le iniziali come le disegna l'avatar: servono anche fuori, per i nomi accessibili */
    static inizialiDi(valore: string | null | undefined): string {
        return (valore ?? '').trim()
            .split(/\s+/)
            .filter(p => p.length > 0 && !AvatarInizialiComponent.TITOLI.test(p))
            .slice(0, 2)
            .map(p => p.charAt(0).toUpperCase())
            .join('');
    }

    /* Un colore solo, il viola: il fondo non varia piu' per persona (21/09/2026).
       Le tre varianti sulla scala viola sembravano casuali — tre colori nella stessa
       scheda — e non distinguevano nessuno, perche' negli elenchi completi le
       iniziali non compaiono. */
    @Input() set nome(valore: string | null | undefined) {
        this.iniziali = AvatarInizialiComponent.inizialiDi(valore);
    }
}
